import { atom } from 'recoil';

export const domainNameExistedState = atom({
  key: 'domain-name-existed-state',
  default: undefined,
});
